module.exports = __webpack_public_path__ + "img/18.1001d308.png";